import {html} from '@isceco/widget-library2/external/lit';
import WebComponent from '../../WebComponent.js';
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import './Navigation/MassnahmenNavigation.js'
import './Region/MassnahmenRegion'

export default class Massnahmen extends WebComponent {

  get translationFile() {
    return './views/Massnahmen/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()

    if (getNavigationHash() === 'Massnahmen') {
      navigate({to: 'Massnahmen_Chot'});
    }

    this.render()
  }

  getTemplate() {
    return html`
      <div style="display: flex;">
        <div style="flex-grow: 0;">
          <gasmonitoring-frontend-massnahmen-navigation></gasmonitoring-frontend-massnahmen-navigation>
        </div>
        <div id="gasContent" style="flex-grow: 1; margin: 0px 0px 0px 40px; width: 100%; height: 100%; overflow: auto;">
          ${this._getContent()}
        </div>
      </div>
    `
  }

  _getContent() {  //NOSONAR
    // check the rights and redirect to default view in verwaltung if not ok
    if (!AuthorizationFilter.viewAllowed(getNavigationHash())) {
      navigate({to: ''})
      return html``
    }
    switch (getNavigationHash()) {
      case 'Massnahmen_Dch':
        return html`<gasmonitoring-frontend-massnahmen-region region="dch"></gasmonitoring-frontend-massnahmen-region>`
      case 'Massnahmen_Chot':
        return html`<gasmonitoring-frontend-massnahmen-region region="chot"></gasmonitoring-frontend-massnahmen-region>`
      case 'Massnahmen_Gaznat':
        return html`<gasmonitoring-frontend-massnahmen-region region="gaznat"></gasmonitoring-frontend-massnahmen-region>`
      case 'Massnahmen_Ail':
        return html`<gasmonitoring-frontend-massnahmen-region region="ail"></gasmonitoring-frontend-massnahmen-region>`
      default:
        break
    }
    // default
    return html``
  }
}
customElements.define('gasmonitoring-frontend-massnahmen', Massnahmen)
